const batsMap = {
  Batting: ['rs', 'fours', 'sixes', 'dks', 'no'],
  'Batting Bonus': [
    '10rs',
    '15rs',
    '20rs',
    '30rs',
    '50rs',
    '75rs',
    '100rs',
    '200rs',
    '0to50sr',
    '50to70sr',
    '70to90sr',
    '90to100sr',
    '100to120sr',
    '120to140sr',
    '140to160sr',
    '160plussr',
    'hobwl',
    'hoct',
    'hocwk',
    'holbw',
    'host',
    'horod',
    'horoa',
    'hohw',
    'hohb',
    'hoobs',
    'hotmd',
    'dotp',
  ],
  Match: ['mtch'],
}

const bowlerMap = {
  Bowling: ['wks', 'mdns', 'hattrick'],
  'Bowling Bonus': [
    '2wks',
    '3wks',
    '4wks',
    '5wks',
    '6wks',
    '7wks',
    '8pluswks',
    '0to2econs',
    '2point01to3econs',
    '3point01to4econs',
    '4point01to5econs',
    '5point01to6econs',
    '6point01to7econs',
    '7point01to8econs',
    '8point01to9econs',
    '9point01to10econs',
    '10plusecons',
    'wb',
    'wct',
    'wcwk',
    'wlbw',
    'wst',
    'whw',
    'dotb',
  ],
  Match: ['mtch'],
}

const wkMap = {
  Fielding: ['cs', 'cwks', 'sts', 'rods', 'roas'],
  'Fielding Bonus': ['3pluscatces'],
  Match: ['mtch'],
}

// AR: merge all three maps, combining arrays under matching category names,
// de-duplicating within each category (mtch appears only once under Match)
const arMapRaw = {}
for (const posMap of [batsMap, bowlerMap, wkMap]) {
  for (const [category, keys] of Object.entries(posMap)) {
    if (!arMapRaw[category]) arMapRaw[category] = []
    for (const key of keys) {
      if (!arMapRaw[category].includes(key)) arMapRaw[category].push(key)
    }
  }
}

const CATEGORY_ORDER = [
  'Batting',
  'Bowling',
  'Fielding',
  'Batting Bonus',
  'Bowling Bonus',
  'Fielding Bonus',
  'Match',
]
const arMap = {}
for (const cat of CATEGORY_ORDER) {
  if (arMapRaw[cat]) arMap[cat] = arMapRaw[cat]
}
// include any unexpected categories not in the fixed order
for (const cat of Object.keys(arMapRaw)) {
  if (!arMap[cat]) arMap[cat] = arMapRaw[cat]
}

export const positionCategoryMap = {
  bats: batsMap,
  bowler: bowlerMap,
  wk: wkMap,
  ar: arMap,
}

// Flat Set of every key belonging to at least one position — used for console.warn
export const allMappedKeys = new Set(
  Object.values(positionCategoryMap).flatMap((posMap) => Object.values(posMap).flat()),
)
